<template>
	<div class="container page game-record-page">
		<van-nav-bar :title="$t('my.order_history')" class="custom-nav" :border="false">
			<template #left>
				<van-icon name="arrow-left" color="#e6b98a" size="24" @click="back()" />
			</template>
		</van-nav-bar>

		<div class="main-content">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<div class="debug-info">
					{{ $t('game_record.debug_info', { count: list.length, total: totalPages }) }}
				</div>
				<van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
				<template v-else>
					<div class="record-list">
						<div class="record-item" v-for="(order, key) in list" :key="key">
							<!-- 订单头部信息 -->
							<div class="item-header">
								<span class="title">
									<van-icon name="orders-o" class="icon gold" />
									{{ $t('game_record.order_number') }}: <span
										class="order-id-val">{{ order.id }}</span>
								</span>
								<span class="status"
									:class="order.status === 1 ? 'status-success' : (order.status === 2 ? 'status-pending' : '')">
									<span v-if="order.status === 1">{{ $t('game_record.status_completed') }}</span>
									<span
										v-else-if="order.status === 2">{{ $t('game_record.status_processing') }}</span>
									<span v-else>
										<button class="complete-btn" @click="completeOrder(order)"
											:disabled="order.completing">
											<van-loading v-if="order.completing" size="16" color="#4a2c1d" />
											<span v-else>{{ $t('game_record.complete_order') }}</span>
										</button>
									</span>
								</span>
							</div>

							<!-- 金额信息 -->
							<div class="item-body">
								<div class="info-row">
									<span class="label">{{ $t('game_record.order_amount') }}:</span>
									<span class="value amount">${{ order.total_amount }}</span>
								</div>
								<div class="info-row">
									<span class="label">{{ $t('game_record.commission') }}:</span>
									<span class="value amount-commission">+${{ order.commission }}</span>
								</div>
								<!-- 时间信息 -->
								<div class="info-row">
									<span class="label">{{ $t('game_record.create_time') }}:</span>
									<span class="value">{{ formatTime(order.create_time) }}</span>
								</div>
							</div>
						</div>
					</div>
				</template>
			</van-pull-refresh>

			<!-- 分页 -->
			<div class="pagination" v-if="totalPages > 1 || list.length > limit">
				<button :disabled="currentPage === 1" @click="changePage(currentPage - 1)" class="page-btn">
					{{ $t('game_record.previous_page') }}
				</button>
				<span
					class="page-info">{{ $t('game_record.page_info', { current: currentPage, total: totalPages }) }}</span>
				<button :disabled="currentPage === totalPages" @click="changePage(currentPage + 1)" class="page-btn">
					{{ $t('game_record.next_page') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import http from '@/http/index'

	export default {
		data() {
			return {
				isLoading: false,
				list: [],
				currentPage: 1,
				totalPages: 1,
				limit: 10
			};
		},
		methods: {
			back() {
				return window.history.back();
			},

			onRefresh() {
				this.getOrderHistory();
				setTimeout(() => {
					this.$toast(this.$t("reservation.refresh"));
					this.isLoading = false;
				}, 500);
			},

			// 获取订单历史
			async getOrderHistory() {
				try {
					const result = await http({
						method: 'get',
						url: 'getOrderHistory',
						data: {
							page: this.currentPage,
							limit: this.limit
						}
					});

					if (result && result.code === 200) {
						// 数据在 data2 字段中
						console.log('获取订单历史成功:', result);

						// 检查 data2 字段
						if (result.data2 && result.data2.data) {
							this.list = result.data2.data || [];
							this.totalPages = result.data2.total_pages || 1;
							console.log('从 data2 获取订单列表:', this.list);
							console.log('从 data2 获取总页数:', this.totalPages);
						} else if (result.data && Array.isArray(result.data)) {
							// 备用：检查 data 字段
							this.list = result.data || [];
							this.totalPages = result.total_pages || 1;
							console.log('从 data 获取订单列表:', this.list);
							console.log('从 data 获取总页数:', this.totalPages);
						} else {
							console.error('未找到订单数据');
							this.list = [];
							this.totalPages = 1;
						}
					} else {
						console.error('获取订单历史失败:', result.msg);
						this.$toast(result.msg || this.$t('game_record.get_order_history_failed'));
					}
				} catch (error) {
					console.error('获取订单历史出错:', error);
					this.$toast(this.$t('game_record.get_order_history_failed_retry'));
				}
			},

			// 切换页面
			changePage(page) {
				if (page >= 1 && page <= this.totalPages) {
					this.currentPage = page;
					this.getOrderHistory();
				}
			},

			// 格式化时间
			formatTime(timeStr) {
				if (!timeStr) return this.$t('game_record.unknown');
				// 如果已经是格式化的时间字符串，直接返回
				if (typeof timeStr === 'string' && timeStr.includes('-')) {
					return timeStr;
				}
				// 如果是时间戳，转换为日期
				if (typeof timeStr === 'number') {
					const date = new Date(timeStr * 1000);
					const year = date.getFullYear();
					const month = String(date.getMonth() + 1).padStart(2, '0');
					const day = String(date.getDate()).padStart(2, '0');
					const hours = String(date.getHours()).padStart(2, '0');
					const minutes = String(date.getMinutes()).padStart(2, '0');
					const seconds = String(date.getSeconds()).padStart(2, '0');
					return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
				}
				return timeStr;
			},

			// 完成订单（付款）
			async completeOrder(order) {
				// 设置加载状态
				this.$set(order, 'completing', true);

				try {
					const result = await http({
						method: 'post',
						url: 'placeOrder',
						data: {
							member_id: 1,
							order_id: order.id,
							quantity: order.quantity || 1
						}
					});

					if (result && result.code === 200) {
						this.$toast(this.$t('game_record.order_complete_success'));
						// 刷新订单列表
						this.getOrderHistory();
					} else if (result.code === 403) {
						this.$toast(this.$t('Lucky')+this.$t('game_record.order_complete_failed') + (result.msg || this.$t(
							'game_record.unknown')));
					setTimeout(()=>{
						this.$router.push('/recharge')
					}, 2000); // 延迟时间，单位是毫秒（3000毫秒 = 3秒）
					
					} else {
						this.$toast(this.$t('game_record.order_complete_failed') + (result.msg || this.$t(
							'game_record.unknown')));
					}
				} catch (error) {
					console.error('完成订单出错:', error);
					this.$toast(this.$t('game_record.order_complete_failed_retry'));
				} finally {
					// 清除加载状态
					this.$set(order, 'completing', false);
				}
			}
		},

		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getOrderHistory();
			}
		},
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.game-record-page {
		background-color: #1f1c1f;
		min-height: 100vh;
		display: flex;
		flex-direction: column;
	}

	/* 导航栏暗金风格 */
	.custom-nav {
		background-color: #2b2b2b !important;
		border-bottom: 2px solid #766350;
	}

	::v-deep .custom-nav .van-nav-bar__title {
		color: #e6b98a !important;
		font-size: 36px;
	}

	::v-deep .van-hairline--bottom::after {
		border-bottom-width: 0 !important;
	}

	.main-content {
		flex: 1;
		overflow-y: auto;
	}

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #e6b98a;
		font-size: 30px;
	}

	.debug-info {
		color: #766350;
		text-align: center;
		padding: 10px;
		font-size: 24px;
	}

	.record-list {
		padding: 20px;
	}

	.record-item {
		background: #2b2b2b;
		border: 1px solid #3a3a3a;
		border-radius: 16px;
		margin-bottom: 20px;
		padding: 24px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
	}

	/* 订单头部 */
	.item-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px dashed #444;
		padding-bottom: 16px;
		margin-bottom: 16px;

		.title {
			color: #fff;
			font-size: 30px;
			font-weight: bold;
			display: flex;
			align-items: center;

			.icon {
				font-size: 36px;
				margin-right: 12px;

				&.gold {
					color: #f3c7a2;
				}
			}

			.order-id-val {
				color: #e6b98a;
				margin-left: 8px;
			}
		}

		.status {
			font-size: 26px;
			padding: 6px 16px;
			border-radius: 20px;

			&.status-pending {
				background: rgba(255, 149, 0, 0.1);
				color: #ff9500;
			}

			&.status-success {
				background: rgba(7, 193, 96, 0.1);
				color: #07c160;
			}
		}
	}

	/* 完成订单按钮 */
	.complete-btn {
		background: linear-gradient(90deg, #efcba7, #dcab76);
		border: none;
		border-radius: 30px;
		padding: 8px 24px;
		color: #4a2c1d;
		font-size: 24px;
		font-weight: bold;
		display: flex;
		align-items: center;
		justify-content: center;
		min-width: 140px;

		&:disabled {
			opacity: 0.7;
		}
	}

	/* 订单信息内容 */
	.item-body {
		.info-row {
			display: flex;
			justify-content: space-between;
			margin-bottom: 12px;
			font-size: 28px;

			&:last-child {
				margin-bottom: 0;
			}

			.label {
				color: #999;
			}

			.value {
				color: #ccc;

				&.amount {
					font-size: 32px;
					font-weight: bold;
					color: #fff;
				}

				&.amount-commission {
					font-size: 32px;
					font-weight: bold;
					color: #07c160;
				}
			}
		}
	}

	/* 分页 */
	.pagination {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 30px 20px;
		margin-bottom: 30px;

		.page-btn {
			background: #2b2b2b;
			border: 1px solid #766350;
			color: #e6b98a;
			padding: 12px 30px;
			border-radius: 8px;
			font-size: 28px;

			&:disabled {
				opacity: 0.5;
				border-color: #444;
				color: #777;
			}
		}

		.page-info {
			margin: 0 30px;
			font-size: 28px;
			color: #999;
		}
	}
</style>